<template>
  <div>
    <a-space>
      <a-button type="primary" @click="addLoadingOrder">{{$t('button.addLoadingOrder')}}</a-button>
      <a-button type="primary" @click="deleteLoadingOrder">{{$t('button.deleteLoadingOrder')}}</a-button>
      <a-button type="primary" @click="issue">{{$t('button.issue')}}</a-button>
      <a-button type="primary" @click="search">{{$t('button.query')}}</a-button>
      <a-button type="primary" @click="reset">{{$t('button.reset')}}</a-button>
    </a-space>
    <br/><br/>
    <a-space>
      <vxe-input
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('placeholder.loadingOrderNo')"
        v-model="query['no']"
      />
      <vxe-input
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.dock')"
        v-model="query['dockNo']"
      />
      <vxe-input
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.vehicleNo')"
        v-model="query['vehicleNo']"
      />
      <vxe-input
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.driver')"
        v-model="query['driver']"
      />
      <vxe-input
        class="query"
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.phone')"
        v-model="query['driverPhone']"
      />
      <a-date-picker
        class="query"
        v-model="query.dateFilter.start"
        :disabled-date="disabledStartDate"
        show-today
        valueFormat="YYYY-MM-DD"
        :placeholder="$t('placeholder.startTime')"
        @change="search"
      />
      <a-date-picker
        class="query"
        v-model="query.dateFilter.end"
        :disabled-date="disabledEndDate"
        show-today
        valueFormat="YYYY-MM-DD"
        :placeholder="$t('placeholder.endTime')"
        @change="search"
      />
    </a-space>
    <vxe-table ref="table" :data="data" :loading="loading" @cell-dblclick="({row})=>rowDblClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.loadingOrderNo"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.operator" title="business.label.maker"/>
      <vxe-column field="order.deliverer" title="business.label.deliver"/>
      <vxe-column field="dock.no" title="business.label.dock"/>
      <vxe-column field="vehicle.no" title="business.label.vehicleNo"/>
      <vxe-column field="order.driver" title="business.label.driver"/>
      <vxe-column field="order.driverPhone" title="business.label.phone"/>
      <vxe-column field="vehicle.type" title="business.label.vehicleType"/>
      <vxe-column field="order.vehicleInPlaceStatus" title="business.label.vehicleInPlaceStatus"/>
      <vxe-column field="order.departureTime" title="business.label.departureTime" width="170"/>
      <vxe-column field="order.notes" title="business.label.notes"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" style="height: 24px" @page-change="pageChange"/>
    <loading-order-editor ref="loadingOrderEditor" @success="refresh"/>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import api from '@/api'
import LoadingOrderEditor from '@/views/delivery/modal/LoadingOrderEditor.vue'

export default {
  name: 'DeliveryLoading',
  components: { LoadingOrderEditor },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      data: [],
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        orderStatus: 0,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      },
      orderType: null
    }
  },
  mounted() {
    this.orderType = this.queryParam.value.business.orderType
    console.log(this.orderType)
    this.getData()
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.dateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.dateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      this.data = []
      const args = Object.assign({}, this.query)
      if (args.dateFilter.start === null && args.dateFilter.end === null) {
        args.dateFilter = null
      }
      findAll('loadingOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
          }
        }
      }).finally(() =>
        this.loading = false
      )
    },
    refresh() {
      this.getData()
    },
    rowDblClick(row) {
      this.$refs.loadingOrderEditor.open([row])
    },
    addLoadingOrder() {
      this.loading = true
      let args = {
        orderType: this.orderType,
        operator: this.operator.name,
        warehouse: this.warehouse,
        distributionType: 2,
        details: []
      }
      post(api.deliverySave, {}, args).then(res => {
        if (res.success) {
          this.$message.success('新增装车单成功')
          this.getData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    deleteLoadingOrder() {
      let that = this
      this.$confirm({
        title: '是否确认删除装车单:',
        onOk() {
          that.cancelLoadingOrder()
        },
        onCancel() {
        },
        centered: true
      })
    },
    cancelLoadingOrder() {
      this.loading = true
      let deleteData = {
        id: this.$refs.table.getCurrentRecord().order.id
      }
      post(api.deliveryCancelOrder, {}, deleteData).then(res => {
        if (res.success) {
          this.$message.success('删除装车单成功')
          this.getData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    issue() {
      const currentRow = this.$refs.table.getCurrentRecord()
      if (currentRow === null) {
        return this.$warning({
          title: '请先选择装车单',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      post(api.deliveryIssue, {}, { no: currentRow.order.no }).then(res => {
        if (res.success) {
          this.$success({
            title: '下发成功',
            centered: true
          })
          this.refresh()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.page = 1
      this.getData()
    },
    reset() {
      this.query = {
        'no': '',
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        orderStatus: 0,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      }
      this.page = 1
      this.getData()
    }
  }
}
</script>

<style scoped>
</style>